import { Box, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(theme => ({
  root: {
    color: "#4CAF50",
    backgroundColor: "#E8F5E9",
    fontWeight: 500,
    fontSize: 12,
    padding: theme.spacing(0.5),
    borderRadius: 2,
    lineHeight: "normal",
    display: "inline-block",
    marginRight: theme.spacing(1),
  },
  hidden: {
    display: "none",
  },
}));

interface AdditionalLanguageFlagProps {
  label: string;
  hidden: boolean;
}

const AdditionalLanguageFlag: React.FC<AdditionalLanguageFlagProps> = ({
  label,
  hidden,
}) => {
  const classes = useStyles();
  return <Box className={hidden ? classes.hidden : classes.root}>{label}</Box>;
};

export default AdditionalLanguageFlag;
